import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftVinculationProps } from './props';
import { SarlaftVinculation } from '../../../../../../shared/types/modules/sarlaft';
import { asyncGetParams } from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useSarlaftVinculation = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftVinculationProps) => {
    const [entailments, setTypeEntailments] = useState<ISelect[]>([]);
    const onSubmit = (data: SarlaftVinculation) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('typeEntailment', data?.typeEntailment || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.TYPE_ENTAILMENT).then((items) =>
            setTypeEntailments(items)
        );
    }, []);

    return {
        formik,
        entailments,
    };
};
